var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgAttendingIcon = function SvgAttendingIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2222 0H1.77778C0.8 0 0.00888888 0.825877 0.00888888 1.83528L0 13.7004C0 14.3336 0.311111 14.8933 0.782222 15.2237L7.51111 19.8486C7.81333 20.0505 8.19556 20.0505 8.49778 19.8486L15.2178 15.2237C15.6889 14.8933 16 14.3336 16 13.7004V1.83528C16 0.825877 15.2 0 14.2222 0ZM13.6 6.1482L6.85333 13.1131C6.50667 13.471 5.94667 13.471 5.6 13.1131L2.40889 9.81877C2.06222 9.46089 2.06222 8.88277 2.40889 8.52489C2.75556 8.16701 3.31556 8.16701 3.66222 8.52489L6.22222 11.1677L12.3378 4.85432C12.6844 4.49644 13.2444 4.49644 13.5911 4.85432C13.9378 5.2122 13.9467 5.79032 13.6 6.1482Z",
    fill: "#272163",
    fillOpacity: 0.5
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAttendingIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/attending-icon.df1be468.svg";
export { ForwardRef as ReactComponent };